import React, { useState, useEffect } from "react";

import { api } from "@/APIRequests";
import {
  Button,
  ButtonTypes,
  Dropdown,
  FormField,
  Modal,
  Text,
  TextColors,
  TextTypes,
} from "@/component-library";

export const ChangePatientStatusPopUp = ({
  cancelHandler,
  confirmHandler,
  newPatientStatus,
  oldPatientStatus,
  patientName,
}) => {
  const [reasonSelected, setReasonSelected] = useState("");
  const [reasonDropdownValue, setReasonDropdownValue] = useState(null);
  const [reasonOptions, setReasonOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await api.public.get_patient_inactivation_reasons({
        params: { showLoader: true },
      });
      const sortedOptions = response.sort((optionA, optionB) =>
        optionA.label.localeCompare(optionB.label),
      );

      setReasonOptions(sortedOptions);
    })();
  }, []);

  const inactivatingPatientEmailInfo =
    'The patient will be notified by email, unless "Deceased" is selected.';

  return (
    <Modal className="ChangePatientStatus" show={true}>
      {newPatientStatus === "INACTIVE" ? (
        <div className="ChangePatientStatus__inactive">
          <Text className="mb-4" type={TextTypes.heading1}>
            You are inactivating {patientName}
          </Text>

          <FormField className="mb-2" label="Reason for Inactivation">
            <Dropdown
              onChange={(e) => {
                setReasonDropdownValue({
                  label: e.target.value,
                  value: e.target.value,
                });
                setReasonSelected(e.target.value);
              }}
              options={reasonOptions}
              placeholder="Select Reason for Inactivation"
              value={reasonDropdownValue}
            />
          </FormField>

          <Text className="mb-4" color={TextColors.grey} type={TextTypes.paragraph}>
            {inactivatingPatientEmailInfo}
          </Text>

          <div className="ChangePatientStatus__buttons">
            <Button buttonType={ButtonTypes.primaryOutline} onClick={cancelHandler}>
              Cancel
            </Button>
            <Button
              buttonType={ButtonTypes.primary}
              disabled={!reasonSelected}
              onClick={() => confirmHandler(reasonSelected)}
            >
              Inactivate Member
            </Button>
          </div>
        </div>
      ) : (
        <div className="ChangePatientStatus__active">
          <Text type={TextTypes.heading1}>Activate Member</Text>

          <div className="ChangePatientStatus__text">
            <Text color={TextColors.grey} type={TextTypes.paragraph}>
              Are you sure you want to activate {patientName}?
            </Text>
            <Text color={TextColors.grey} type={TextTypes.paragraph}>
              Their status will be changed to their previous active status: {oldPatientStatus}
            </Text>
          </div>

          <div className="ChangePatientStatus__buttons">
            <Button buttonType={ButtonTypes.primaryOutline} onClick={cancelHandler}>
              No, Cancel
            </Button>
            <Button buttonType={ButtonTypes.primary} onClick={() => confirmHandler()}>
              Yes, Activate Member
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
